import produce from 'immer';
import * as ACTIONS from '../../actionTypes/priceOfferListActionTypes';

const initialState = {
  isLoading: true,
  packages: [],
  isCharter: null,
};

export default produce((draft, action) => {
  switch (action.type) {
    case ACTIONS.INIT_SUCCESS:
      draft.isLoading = false;
      draft.packages = action.packages;
      draft.isCharter = action.isCharter;
      break;
    default:
  }
}, initialState);
